<script setup>
import { reactive, ref } from "vue";
import { useAuth } from "@/stores/auth";
import Notifications from "@/composables/notifications";
import { handleApiException } from "@/composables/exceptions.js";
import { t } from "i18next";
import Dialog from "@/components/modals/Dialog.vue";

const auth = useAuth();
const modal = ref(null);

const state = reactive({
  code: null, // Code verification input commented - email verified via link
  userEmail: null,
});

const showModal = async (email = null) => {
  state.userEmail = email;

  if (email) {
    // For unverified users (registration flow)
    try {
      await auth.sendUnverifiedConfirmationEmail(email);
    } catch (e) {
      console.error("Failed to send confirmation email:", e);
    }
  } else {
    // For authenticated users
    auth.sendConfirmationEmail();
  }

  modal.value.show();
};

const closeModal = () => {
  modal.value.hide();
};

// Code verification - email verified via link instead
// const confirmEmail = async () => {
//   try {
//     let response;
//     if (state.userEmail) {
//       response = await auth.confirmUnverifiedEmail(state.userEmail, state.code);
//       if (response.data?.token) auth.setAuthToken(response.data.token);
//       else if (response.data?.user) auth.setUser(response.data.user);
//     } else {
//       response = await auth.confirmEmail(state.code);
//       await auth.loadUser();
//     }
//     Notifications.success(t("header.auth.emailConfirmed"));
//     closeModal();
//   } catch (e) {
//     handleApiException(e);
//     if (e.response?.data?.message) Notifications.alert(e.response.data.message);
//   }
// };

const resendEmail = async () => {
  try {
    if (state.userEmail) {
      await auth.sendUnverifiedConfirmationEmail(state.userEmail);
    } else {
      await auth.sendConfirmationEmail();
    }
    Notifications.success(t("header.auth.emailSent"));
  } catch (e) {
    handleApiException(e);
    Notifications.alert(t("exceptions.somethingWentWrongTryAgain"));
  }
};

defineExpose({
  showModal,
});
</script>

<template>
  <Dialog ref="modal" parent-classes="confirm-email-modal" :rounded="false">
    <div class="card p-2 rounded-0">
      <div class="card-body">
        <h6>{{ t("header.auth.pleaseConfirmYourEmail") }}</h6>
        <p class="text-muted mb-3">{{ t("header.auth.checkEmailForLink") }}</p>
        <div v-if="state.userEmail" class="alert alert-info mb-3">
          <strong>{{ state.userEmail }}</strong>
        </div>
        <!-- Code verification input - email verified via link instead
        <div class="input-group mb-3">
          <input
              v-model="state.code"
              placeholder="Confirmation code"
              autocomplete="one-time-code"
              class="form-control rounded-0"
          />
          <button @click="confirmEmail" class="btn btn-primary rounded-0">
            {{ t("header.auth.confirm") }}
          </button>
        </div>
        -->
        <div class="d-flex flex-column gap-2">
          <button @click="closeModal" class="btn btn-primary rounded-0">
            {{ t("header.auth.gotIt") }}
          </button>
          <p class="small text-muted mb-0 text-center">
            {{ t("header.auth.didntGetEmail1") }}
            <span @click="resendEmail" class="text-primary pointer">{{ t("header.auth.didntGetEmail2Click") }}</span>
            {{ t("header.auth.didntGetEmail3") }}
          </p>
        </div>
      </div>
    </div>
  </Dialog>
</template>
